
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bimi-logo-ai-wizard",
      function () {
        return require("private-next-pages/bimi-logo-ai-wizard.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bimi-logo-ai-wizard"])
      });
    }
  